// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  SvgIcon,
  Warning,
  Spinner
} from '../'

import { default as EventRequest } from './EventRequest'

const QUERY_EVENT = gql`
  query($id: ID!) {
    event(id: $id) {
      id
      eventData
      eventType
    }
  }
`

const WhatsAppEventDetails = ({ eventId }) => {
  if (eventId) {
    return (
      <Query
        query={QUERY_EVENT}
        variables={{ id: eventId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div className='slds-is-relative' style={{ height: '80vh' }}>
                <Spinner type='brand' size='large' />
              </div>
            )
          }

          if (error) {
            return (
              <Warning>
                Failed to fetch event data.
              </Warning>
            )
          }

          const detailsParsed = JSON.parse(data.event.eventData)

          return (
            <div className='slds-size_1-of-1 rounded-container' style={{ height: '86vh' }}>
              <div className='u-font-size-large slds-p-around_small slds-border_bottom slds-align_absolute-center'>
                Event details
              </div>
              <div className='slds-p-around_xx-small slds-scrollable section-details' style={{ height: '76vh' }}>
                {data.event.eventType === 'picsaos.request'
                  ? <EventRequest request={detailsParsed.request} result={detailsParsed.result} />
                  : <div
                      className='slds-grid slds-wrap slds-p-top_large slds-p-left_small slds-p-right_small'
                      style={{ justifyContent: 'space-around' }}>
                      {Object.keys(detailsParsed).map(key => (
                        <dl key={`eventDetails_${key}`}>
                          <dd className='slds-item_label slds-text-title_caps'>
                            {key}
                          </dd>
                          <dt className='slds-item_detail'>
                            {detailsParsed[key]}
                          </dt>
                        </dl>
                      ))}
                    </div>
                }
              </div>
            </div>
          )
        }}
      </Query>
    )
  } else {
    return (
      <div>
        <SvgIcon
          variant='utility'
          symbol='info'
          size='small'
          colour='light'
          className='slds-m-right_small'
        />
        Select event to display details.
      </div>
    )
  }

}

export default WhatsAppEventDetails



// WEBPACK FOOTER //
// ./src/components/whatsapp-message-event-details/index.js